import Vue from 'vue'

import Vuetify from 'vuetify/dist/vuetify.min.js'
import 'vuetify/dist/vuetify.min.css'
// import Vuetify from 'vuetify'
// import 'vuetify/src/stylus/app.styl'

Vue.use(Vuetify, {
  iconfont: 'md',
  theme: {
    options: {
      customProperties: true,
    },
  },
})
